<template>
  <div class="payment-list">
    <el-card>
      <div slot="header">
        <span>收费记录</span>
      </div>

      <el-table :data="tableData" border stripe>
        <el-table-column prop="plateNumber" label="车牌号" width="120"></el-table-column>
        <el-table-column prop="parkingLotName" label="停车场" width="150"></el-table-column>
        <el-table-column prop="entryTime" label="入场时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entryTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="exitTime" label="出场时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.exitTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="停车时长" width="120">
          <template slot-scope="scope">
            {{ formatDuration(scope.row.duration) }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="100" align="right">
          <template slot-scope="scope">
            <span style="color: #ff7e00; font-weight: bold;">¥{{ scope.row.amount.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.paymentStatus === 'paid' ? 'success' : 'danger'" size="small">
              {{ scope.row.paymentStatus === 'paid' ? '已支付' : '未支付' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.paymentStatus === 'unpaid'" type="primary" size="small" @click="handlePay(scope.row.id)">
              支付
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { paymentApi } from '@/api'

export default {
  data() {
    return {
      tableData: []
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const { data } = await paymentApi.getList()
        this.tableData = data
      } catch (error) {
        this.$message.error('加载失败')
      }
    },
    formatTime(time) {
      return new Date(time).toLocaleString('zh-CN')
    },
    formatDuration(minutes) {
      const hours = Math.floor(minutes / 60)
      const mins = minutes % 60
      return `${hours}小时${mins}分钟`
    },
    async handlePay(id) {
      try {
        await this.$confirm('确定支付?', '提示', { type: 'warning' })
        await paymentApi.pay(id)
        this.$message.success('支付成功')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('支付失败')
        }
      }
    }
  }
}
</script>
